import { LotCodeDto } from "../..";

export class LotCodeTreeDto{
    lotCode:LotCodeDto[];
    constructor(lotCode:LotCodeDto[],) { 
          this.lotCode = lotCode; 
        }
}